import { ProgramTypes } from 'legacy/lut/classes/models/ProgramTypes'

import { CORE_TOP_PARTNER_FLAGS, PS_TOP_PARTNER_FLAGS } from '../config'
import { IPartnerFlag } from '../models/IPartnerFlag'

/**
 * Use flags:
 *  IsOpsTopPartner - Core Print
 *  IsBpsTopPartner - Personal Systems
 *  IsTopPartner (for Distributor) - Print, PC, Supplies
 */
export const isTopPartner = (
  programType: string,
  partnerFlagsState: IPartnerFlag[],
  isTopDistributor: boolean
) => {
  let isTop = false

  if (
    programType === ProgramTypes.Print ||
    programType === ProgramTypes.PC ||
    programType === ProgramTypes.Supplies
  ) {
    isTop = isTopDistributor
  } else {
    isTop = partnerFlagsState.some((el) => {
      if (programType === ProgramTypes.CorePrint) {
        return el.isEnabled && el.name === CORE_TOP_PARTNER_FLAGS
      } else if (programType === ProgramTypes.PersonalSystems) {
        return el.isEnabled && el.name === PS_TOP_PARTNER_FLAGS
      }

      return false
    })
  }

  return isTop
}
